<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-info">
            <p class="modal-card-title">{{$t('MODALOBSERVACAORESPOSTA.MENSAGEMOBSERVACAORESPOSTA')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">
            <div class="panel">
                <p class="panel-block">
                    <b-field :label="$t('SISTEMA.OBSERVACAO')">
                    </b-field>
                </p>
                <div class="panel-block">
                    <textarea class="textarea" v-model="observacoes" rows="4"></textarea>                                      
                </div>                

            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                     :loading="salvandoDados"
                      @click="incluirObservacao">{{$t('SISTEMA.INCLUIR')}}</b-button>
            <b-button @click="$emit('close')">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import http from '@/http'
    import { mapState } from 'vuex'
    
    export default {
        props: {
            observacaoId: Number,
            astec:{
                type: Boolean,
                defaut: false
            },                                                      
        },
        data() {
            return {                              
                observacoes: null,
                salvandoDados :false
            }
        },
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),  
        },        

        mounted() {
            return true;
        },
        methods: {

            async incluirObservacao(){

                this.salvandoDados=true;
                

                if (this.observacoes== null  || this.observacoes == '' || this.observacoes == undefined) {
                    this.salvandoDados = false;
                    return;
                }      
                
                const guiaObservacao = {
                    guiaObservacaoId: this.observacaoId,
                    observacao : this.observacoes
                }                
                this.isLoading = true;  


                
                let url ='/api/atendimento/GuiaObservacoesResposta';


                if(this.astec){
                    url ='/api/astecs/GuiaObservacoesResposta';
                }
                                
                
                try {
                    http.post(url, guiaObservacao)
                        .then(() => {
                            this.salvandoDados=false;
                            return true;

                        }).finally(() => {                                
                            this.salvandoDados=false;    
                            this.observacoes = null;

                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t('GUIAATENDIMENTO.MENSAGEMOBSERVACAOSALVA'),
                                type: 'is-success'
                            }); 
                            
                            this.$emit('loadData')                                                            
                            this.$emit('close');                                                                                   
                        }); 
                        
                    } catch (e) {
                        this.salvandoDados=false;                        
                        console.error(e);
                    }                    
            },            
            
        }
    }
</script>
